import { render, staticRenderFns } from "./additionalInformationComponent.vue?vue&type=template&id=653476dd&"
import script from "./additionalInformationComponent.vue?vue&type=script&lang=js&"
export * from "./additionalInformationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports